import { StyledLabel } from './Label.styles';
import type { LabelProps } from './Label.types';

export const Label = ({ htmlId, label }: LabelProps) => {
  return <StyledLabel htmlFor={htmlId}>{label}</StyledLabel>;
};
